<template>
  <div :class="containerClasses" class="flex items-center gap-2 relative leading-6 pt-1.5">
    <ToggleSwitch
      ref="toggleRef"
      :pt="{
        root: { class: `switch-container ${toggleClasses} mr-0 relative inline-flex h-6 w-12 shrink-0 cursor-pointer rounded-full border-3 border-transparent transition-colors duration-200 ease-in-out` },
        slider: { class: `slider-circle ${sliderClasses} translate-x-0 absolute pointer-events-none top-0 inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out` },
        input: { 
          name: props.name,
          id: inputId,
          value: '1',
          ...$attrs
        }
      }"
      v-model="checked"
      :aria-label="srLabel"
    />
  </div>
</template>

<script setup>
  defineOptions({
    inheritAttrs: false
  });

  import { ref, computed } from 'vue'
  import ToggleSwitch from 'primevue/toggleswitch'

  const props = defineProps({
    name:           { type: String },
    srLabel:        { type: String, required: true},
    horizontal:     { type: Boolean, default: false }
  })

  const checked = ref(props.initialChecked)

  const inputId = computed(() =>
    props.name ? props.name.replace(/[^a-zA-Z0-9_-]/g, '_') : ''
  )

  const containerClasses = computed(() => ({
    'toggle-switch': true,
    'flex flex-row-reverse w-max': props.horizontal
  }))

  const sliderClasses = computed(() =>
    `transition-all duration-200 ease-in-out ${checked.value ? 'translate-x-6' : 'translate-x-0'}`
  )

  const toggleClasses = computed(() =>
    `transition-colors duration-200 ease-in-out ${checked.value ? 'bg-blue-500 unlocked' : 'bg-gray-200 locked'}`
  )
</script>
